const $ = jQuery;
const Slick = {
  init: function () {
    $(".slider-for").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      draggable: true,

      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 420,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    $(".slider-for").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        progressBar(currentSlide, false);
      }
    );
    function progressBar(index = 0, loaded = true) {
      var progressBar = $(".progress-bar__inner");
      var itemWidth = 100 / parseInt($(".slider-for").data("count"));
      var progress = (index + 1) * itemWidth;
      progressBar.css("width", progress + "%");
      if (loaded) $(".slider-for").slick("slickGoTo", index);
    }

    progressBar();

    $(".progress-bar").on("click", function (event) {
      var barWidth = $(this).width();
      var clickX = event.pageX - $(this).offset().left;
      var index = Math.floor(
        (clickX / barWidth) * parseInt($(".slider-for").data("count"))
      );
      progressBar(index);
    });
  },
};

export default Slick;
